import App from '@/App.vue'
import ElementPlusIcons from '@/plugins/ElementPlusIcons'
import ErrorHandler from '@/plugins/ErrorHandler'
import GlobalProperties from '@/plugins/GlobalProperties'
import router from '@/router'
import pinia from '@/store'
import '@/styles/main.scss'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { createApp } from 'vue'
import system from '../public/system.json'

declare global {
  interface Window {
    __version: string
  }
}

window.ResizeObserver = class _NewResizeObserver extends ResizeObserver {
  constructor(callback: any) {
    // super(() => window.requestAnimationFrame(() => callback.apply(this, arguments)))
    super((entries, observer) => {
      window.requestAnimationFrame(() => callback(entries, observer))
    })
  }
}

window.__version = system.data.__version

console.log('BUILD_TIME', BUILD_TIME)

createApp(App)
  .use(router)
  .use(pinia)
  .use(ElementPlus)
  .use(ElementPlusIcons)
  .use(ErrorHandler)
  .use(GlobalProperties)
  .mount('#app')
